import React from 'react'

const Progress_bar = ({ bgcolor, progress, height, name }) => {

    const Parentdiv = {
        height: height,
        width: '100%',
        backgroundColor: '#cbcbcb',
        borderRadius: 0,
        margin: "0 0 15px"
    }

    const Childdiv = {
        height: '100%',
        width: `${progress}%`,
        backgroundColor: bgcolor,
        borderRadius: 0,
        textAlign: 'right'
    }

    const progresstext = {
        padding: 10,
        color: 'black',
        fontWeight: 900
    }

    return (
        <>
            <div className='textpp'>
                <p>{name}</p>
                <p>{progress} %</p>
            </div>
            <div style={Parentdiv}>
                <div style={Childdiv}>
                    <span style={progresstext}></span>
                </div>
            </div>
        </>

    )
}

export default Progress_bar;
